import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    lineTitle: "",
    keyword: "title1",
    type: "lineTitle",
    showLine: true,
  },
  {
    title: "契約者（法人）名",
    keyword: "corpName",
    type: "text",
    showLine: false,
  },
  {
    title: "職員名",
    keyword: "staffNameKanji",
    type: "text",
  },
  {
    title: "性別",
    keyword: "sex",
    type: "text",
  },
  {
    title: "職種",
    keyword: "jobName",
    type: "text",
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "text",
  },
  {
    title: "加入日",
    keyword: "firstJoinDate",
    type: "text",
  },
  {
    title: "在籍期間",
    keyword: "enroll",
    type: "text",
  },
  {
    title: "退職日",
    keyword: "retireDate",
    type: "text",
  },
  {
    title: "俸給表の額",
    keyword: "salaryTableAmt",
    type: "text",
  },
  {
    title: "俸給の調整額",
    keyword: "salaryAdjustmentAmt",
    type: "text",
  },
  {
    title: "合計",
    keyword: "sum",
    type: "text",
  },
  {
    lineTitle: "",
    keyword: "title2",
    type: "lineTitle",
  },
  {
    title: "退職届提出日",
    keyword: "applyDate",
    type: "text",
  },
  {
    title: "支給額",
    keyword: "paymentAmt",
    type: "text",
  },
  {
    title: "送金予定日",
    keyword: "remitDueDate",
    type: "text",
  },
  {
    lineTitle: "",
    keyword: "title3",
    type: "lineTitle",
  },
  {
    title: "ならない月",
    keyword: "unrecognizedMonthList",
    type: "nodeInLine",
  },
  {
    title: "テーブル",
    keyword: "childcareLeaveList",
    type: "node",
  },
  {
    title: "異動履歴",
    keyword: "transferHistoryList",
    type: "multipleLinesWithBorder",
  },
  {
    lineTitle: "",
    keyword: "title4",
    type: "lineTitle",
  },
  {
    title: "メールアドレス",
    keyword: "email",
    type: "mail",
    requiredIcon: true,
    inputProps: [{ minLength: 1 }, { maxLength: 255 }],
  },
  {
    title: "メールアドレス（確認用）",
    keyword: "emailConfirm",
    type: "mail",
    requiredIcon: true,
    inputProps: [{ minLength: 1 }, { maxLength: 255 }],
  },
];

const infoHeadTitleList = [
  {
    headTitle: "出産日",
  },
  {
    headTitle: "育児休業開始日",
  },
  {
    headTitle: "育児休業終了日",
  },
  {
    headTitle: "パパママ育休プラス",
  },
  {
    headTitle: "半年延長の理由",
  },
  {
    headTitle: "産後パパ育休",
  },
];

const memoTable: ITkFakeTableLineProps[] = [
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: "メモ",
  },
  {
    title: "メモ",
    keyword: "memo",
    type: "textarea",
    inputProps: { maxLength: 100 },
  },
];

const schema: any = {
  email: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
  },
  emailConfirm: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
  },
};

const monthMapping: { [key: number]: string } = {
  0: "4",
  1: "5",
  2: "6",
  3: "7",
  4: "8",
  5: "9",
  6: "10",
  7: "11",
  8: "12",
  9: "1",
  10: "2",
  11: "3",
};

export { fakeTableList, schema, infoHeadTitleList, memoTable, monthMapping };
